/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Bundle_Bundlepricelabel2Inputs */

const id_components_bundle_bundlepricelabel2 = /** @type {(inputs: Components_Bundle_Bundlepricelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harga Bundel:`)
};

const ms_components_bundle_bundlepricelabel2 = /** @type {(inputs: Components_Bundle_Bundlepricelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harga Bundle:`)
};

const da_components_bundle_bundlepricelabel2 = /** @type {(inputs: Components_Bundle_Bundlepricelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bundle Pris:`)
};

const de_components_bundle_bundlepricelabel2 = /** @type {(inputs: Components_Bundle_Bundlepricelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bundle-Preis:`)
};

const en_us2_components_bundle_bundlepricelabel2 = /** @type {(inputs: Components_Bundle_Bundlepricelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bundle Price:`)
};

const es_es2_components_bundle_bundlepricelabel2 = /** @type {(inputs: Components_Bundle_Bundlepricelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precio del bundle:`)
};

const es_mx2_components_bundle_bundlepricelabel2 = /** @type {(inputs: Components_Bundle_Bundlepricelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precio del paquete:`)
};

const fil_components_bundle_bundlepricelabel2 = /** @type {(inputs: Components_Bundle_Bundlepricelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Presyo ng Bundle:`)
};

const fr_components_bundle_bundlepricelabel2 = /** @type {(inputs: Components_Bundle_Bundlepricelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prix du bundle :`)
};

const it_components_bundle_bundlepricelabel2 = /** @type {(inputs: Components_Bundle_Bundlepricelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prezzo bundle:`)
};

const hu_components_bundle_bundlepricelabel2 = /** @type {(inputs: Components_Bundle_Bundlepricelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Csomag ár:`)
};

const nl_components_bundle_bundlepricelabel2 = /** @type {(inputs: Components_Bundle_Bundlepricelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bundelprijs:`)
};

const no_components_bundle_bundlepricelabel2 = /** @type {(inputs: Components_Bundle_Bundlepricelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buntpris:`)
};

const pl_components_bundle_bundlepricelabel2 = /** @type {(inputs: Components_Bundle_Bundlepricelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cena pakietu:`)
};

const pt_br2_components_bundle_bundlepricelabel2 = /** @type {(inputs: Components_Bundle_Bundlepricelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bundle Price:`)
};

const pt_components_bundle_bundlepricelabel2 = /** @type {(inputs: Components_Bundle_Bundlepricelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preço do pacote:`)
};

const ro_components_bundle_bundlepricelabel2 = /** @type {(inputs: Components_Bundle_Bundlepricelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preț pachet:`)
};

const fi_components_bundle_bundlepricelabel2 = /** @type {(inputs: Components_Bundle_Bundlepricelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paketin hinta:`)
};

const sv_components_bundle_bundlepricelabel2 = /** @type {(inputs: Components_Bundle_Bundlepricelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paketpris:`)
};

const vi_components_bundle_bundlepricelabel2 = /** @type {(inputs: Components_Bundle_Bundlepricelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giá gói:`)
};

const tr_components_bundle_bundlepricelabel2 = /** @type {(inputs: Components_Bundle_Bundlepricelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paket Fiyatı:`)
};

const cs_components_bundle_bundlepricelabel2 = /** @type {(inputs: Components_Bundle_Bundlepricelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cena balíčku:`)
};

const bg_components_bundle_bundlepricelabel2 = /** @type {(inputs: Components_Bundle_Bundlepricelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цена на пакета:`)
};

const ru_components_bundle_bundlepricelabel2 = /** @type {(inputs: Components_Bundle_Bundlepricelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цена пакета:`)
};

const uk_components_bundle_bundlepricelabel2 = /** @type {(inputs: Components_Bundle_Bundlepricelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ціна набору:`)
};

const ar_components_bundle_bundlepricelabel2 = /** @type {(inputs: Components_Bundle_Bundlepricelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سعر الحزمة:`)
};

const hi_components_bundle_bundlepricelabel2 = /** @type {(inputs: Components_Bundle_Bundlepricelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बंडल मूल्य:`)
};

const th_components_bundle_bundlepricelabel2 = /** @type {(inputs: Components_Bundle_Bundlepricelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ราคาชุดรวม:`)
};

const ja_components_bundle_bundlepricelabel2 = /** @type {(inputs: Components_Bundle_Bundlepricelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`バンドル価格：`)
};

const zh_cn2_components_bundle_bundlepricelabel2 = /** @type {(inputs: Components_Bundle_Bundlepricelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bundle Price:`)
};

const zh_hant1_components_bundle_bundlepricelabel2 = /** @type {(inputs: Components_Bundle_Bundlepricelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bundle Price:`)
};

const ko_components_bundle_bundlepricelabel2 = /** @type {(inputs: Components_Bundle_Bundlepricelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bundle Price:`)
};

/**
* | output |
* | --- |
* | "Bundle Price:" |
*
* @param {Components_Bundle_Bundlepricelabel2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_bundle_bundlepricelabel2 = /** @type {((inputs?: Components_Bundle_Bundlepricelabel2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Bundle_Bundlepricelabel2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_bundle_bundlepricelabel2(inputs)
	if (locale === "ms") return ms_components_bundle_bundlepricelabel2(inputs)
	if (locale === "da") return da_components_bundle_bundlepricelabel2(inputs)
	if (locale === "de") return de_components_bundle_bundlepricelabel2(inputs)
	if (locale === "en-US") return en_us2_components_bundle_bundlepricelabel2(inputs)
	if (locale === "es-ES") return es_es2_components_bundle_bundlepricelabel2(inputs)
	if (locale === "es-MX") return es_mx2_components_bundle_bundlepricelabel2(inputs)
	if (locale === "fil") return fil_components_bundle_bundlepricelabel2(inputs)
	if (locale === "fr") return fr_components_bundle_bundlepricelabel2(inputs)
	if (locale === "it") return it_components_bundle_bundlepricelabel2(inputs)
	if (locale === "hu") return hu_components_bundle_bundlepricelabel2(inputs)
	if (locale === "nl") return nl_components_bundle_bundlepricelabel2(inputs)
	if (locale === "no") return no_components_bundle_bundlepricelabel2(inputs)
	if (locale === "pl") return pl_components_bundle_bundlepricelabel2(inputs)
	if (locale === "pt-BR") return pt_br2_components_bundle_bundlepricelabel2(inputs)
	if (locale === "pt") return pt_components_bundle_bundlepricelabel2(inputs)
	if (locale === "ro") return ro_components_bundle_bundlepricelabel2(inputs)
	if (locale === "fi") return fi_components_bundle_bundlepricelabel2(inputs)
	if (locale === "sv") return sv_components_bundle_bundlepricelabel2(inputs)
	if (locale === "vi") return vi_components_bundle_bundlepricelabel2(inputs)
	if (locale === "tr") return tr_components_bundle_bundlepricelabel2(inputs)
	if (locale === "cs") return cs_components_bundle_bundlepricelabel2(inputs)
	if (locale === "bg") return bg_components_bundle_bundlepricelabel2(inputs)
	if (locale === "ru") return ru_components_bundle_bundlepricelabel2(inputs)
	if (locale === "uk") return uk_components_bundle_bundlepricelabel2(inputs)
	if (locale === "ar") return ar_components_bundle_bundlepricelabel2(inputs)
	if (locale === "hi") return hi_components_bundle_bundlepricelabel2(inputs)
	if (locale === "th") return th_components_bundle_bundlepricelabel2(inputs)
	if (locale === "ja") return ja_components_bundle_bundlepricelabel2(inputs)
	if (locale === "zh-CN") return zh_cn2_components_bundle_bundlepricelabel2(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_bundle_bundlepricelabel2(inputs)
	return ko_components_bundle_bundlepricelabel2(inputs)
});
export { components_bundle_bundlepricelabel2 as "components.bundle.bundlePriceLabel" }